import React, { useContext } from "react";
import { ThemeContext } from "styled-components";
import { Box } from "@bca/ui-library";

import StyledIcon from "../Interfaces/StyledIcon";

const PurchasePriceSVG: React.FunctionComponent<StyledIcon> = ({
  fill = "primary-navy-blue",
  ...props
}) => {
  const theme = useContext(ThemeContext);
  const hexColor = theme.colors["primary-navy-blue"] || "primary-navy-blue";

  return (
    <Box {...props}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7539 6.99609C17.8945 7.17188 18 7.38281 18 7.59375C18 7.83984 17.8945 8.05078 17.7539 8.19141L13.3945 12.5859C13.1836 12.7617 12.9727 12.832 12.7617 12.832C12.5508 12.832 12.3398 12.7617 12.1992 12.5859L11.3906 11.7773C11.2148 11.6367 11.1445 11.4258 11.1445 11.1797C11.1445 10.9688 11.2148 10.7578 11.3906 10.582L11.6016 10.4062L10.1953 9L7.34766 11.8477L7.55859 12.0586C7.76953 12.2695 7.875 12.5508 7.875 12.8672C7.875 13.1836 7.76953 13.4297 7.55859 13.6406L3.51563 17.6836C3.30469 17.8945 3.02344 18 2.70703 18C2.39063 18 2.14453 17.8945 1.93359 17.6836L0.316406 16.0664C0.105469 15.8555 0 15.6094 0 15.293C0 14.9766 0.105469 14.6953 0.316406 14.4844L4.35938 10.4414C4.57031 10.2305 4.81641 10.125 5.13281 10.125C5.44922 10.125 5.73047 10.2305 5.94141 10.4414L6.15234 10.6523L9 7.80469L7.59375 6.39844L7.41797 6.60938C7.24219 6.78516 7.03125 6.85547 6.82031 6.85547C6.57422 6.85547 6.36328 6.78516 6.22266 6.60938L5.41406 5.80078C5.23828 5.66016 5.16797 5.44922 5.16797 5.23828C5.16797 5.02734 5.23828 4.81641 5.41406 4.60547L9.80859 0.246094C9.94922 0.105469 10.1602 0 10.4063 0C10.6172 0 10.8281 0.105469 11.0039 0.246094L11.7773 1.05469C11.918 1.23047 12.0234 1.44141 12.0234 1.65234C12.0234 1.89844 11.918 2.10938 11.7773 2.25L11.6016 2.42578L15.5742 6.39844L15.75 6.22266C15.8906 6.08203 16.1016 5.97656 16.3477 5.97656C16.5586 5.97656 16.7695 6.08203 16.9453 6.22266L17.7539 6.99609Z"
          fill={hexColor}
        />
      </svg>
    </Box>
  );
};

export default PurchasePriceSVG;
